import { render, staticRenderFns } from "./EvidenciaBHPPantalla.vue?vue&type=template&id=05a4aab0&"
import script from "./EvidenciaBHPPantalla.vue?vue&type=script&lang=ts&"
export * from "./EvidenciaBHPPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports